var render = function () {
  var _vm$history;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.activityLogEntry.target && _vm.entity && (_vm$history = _vm.history) !== null && _vm$history !== void 0 && _vm$history.message ? _c('timeline-card', {
    attrs: {
      "title": _vm.text,
      "color": _vm.entity.statusColor
    },
    scopedSlots: _vm._u([{
      key: "menu",
      fn: function fn() {
        return [_vm.$vuetify.breakpoint.smAndDown ? _c('div', {
          staticClass: "mr-4"
        }, [_c('context-menu', [_vm.showReplyButton ? _c('v-list-item', {
          on: {
            "click": _vm.openReplyDialog
          }
        }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-reply")])], 1), _c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("common.verbs.reply")))])], 1) : _vm._e(), _c('activity-time-line-item-delete', {
          attrs: {
            "text": true,
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        })], 1)], 1) : _c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_vm.showReplyButton ? _c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "x-small": "",
            "dense": "",
            "outlined": "",
            "color": "info"
          },
          on: {
            "click": _vm.openReplyDialog
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.reply")) + " ")]) : _vm._e(), _c('activity-time-line-item-delete', {
          staticClass: "mr-4",
          attrs: {
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 3399872606)
  }, [_c('v-card-text', {
    staticClass: "white-space-pre-wrap"
  }, [_vm._v(" " + _vm._s(_vm.history.message) + " ")])], 1) : _vm.activityLogEntry.target && _vm.entity ? _c('time-line-item-text', {
    attrs: {
      "icon": 'mdi-state-machine',
      "fill-dot": "",
      "color": _vm.entity.statusColor,
      "small": "",
      "text": _vm.text
    },
    scopedSlots: _vm._u([{
      key: "menu",
      fn: function fn() {
        return [_vm.$vuetify.breakpoint.smAndDown ? _c('div', {
          staticClass: "mr-4"
        }, [_c('context-menu', [_vm.showReplyButton ? _c('v-list-item', {
          on: {
            "click": _vm.openReplyDialog
          }
        }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-reply")])], 1), _c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("common.verbs.reply")))])], 1) : _vm._e(), _c('activity-time-line-item-delete', {
          attrs: {
            "text": true,
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        })], 1)], 1) : _c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_vm.showReplyButton ? _c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "icon": "",
            "small": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openReplyDialog
          }
        }, [_c('v-icon', [_vm._v("mdi-reply")])], 1) : _vm._e(), _c('activity-time-line-item-delete', {
          staticClass: "mr-4",
          attrs: {
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        })], 1)];
      },
      proxy: true
    }])
  }) : _vm._e(), _c('template-dialog', {
    ref: "replyToInformationRequestDialog",
    attrs: {
      "hideButton": true,
      "from": [_vm.partner],
      "to": _vm.to,
      "refs": _vm.refs,
      "context": _vm.context
    },
    on: {
      "sent": _vm.resetStateBackToRequested
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }